var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"standart-btn-action",class:{
      danger: _vm.type === 'danger',
      success: _vm.type === 'success'
    },attrs:{"disabled":_vm.disabled}},[_c('img',{attrs:{"src":require(("@/assets/" + _vm.src)),"alt":_vm.desc}})])}
var staticRenderFns = []

export { render, staticRenderFns }